module.exports = __webpack_public_path__ + "img/delete.5c21d6cd.svg";